import React, { useEffect } from 'react'


import classes from './PopupObjective.module.css'
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Texts from 'react-sdk/Texts';
import clsx from 'clsx';
import SoundPlayer from 'react-sdk/SoundPlayer';
import Rays from '@/components/shared/Rays/Rays';
import Objective from '@/js/Objectives/Objective';
import Analytics from 'react-sdk/Vertx/Analytics';
import Button from '@/components/shared/Button/Button';
import Periods from '@/js/Periods';


const PopupObjective = () => {
  /** @type {Objective} */
  let obj = PopupsManager.getData(POPUPS.NEW_OBJECTIVE)

  let isChapter = !obj.parent

  useEffect(() => {

    if(!isChapter) setTimeout(() => {
      handleClickDiv()
    }, 1000)

  }, [])
  

  useEffect(() => {
    SoundPlayer.playSound("quest_start")

    const evt = "OBJECTIVE : " + obj.id

    Analytics.contentEventShow(evt)

    return () => {
      Analytics.contentEventHide(evt)
    }



  }, []);

  function handleClickDiv() {
    if(!isChapter) handleClose()
  }

  function handleClose() {
    PopupsManager.close(POPUPS.NEW_OBJECTIVE)
  }

  return (

    <div className={clsx(classes.PopupObjective, isChapter && classes.chapter, !isChapter && classes.notif)} onClick={handleClickDiv}>

      {isChapter && <>
        <img className={ classes.obj_img } src={ Texts.get("objectif-img-" + obj.id) } />
      </>}

      <div className={classes.content}>
        {/* {isChapter && <div className={classes.title}>{Texts.get("popup-chapter-title")}</div>} */}
        {/* {!isChapter && <div className={classes.title}>{Texts.get("popup-objectifs-title")}</div>} */}
        {isChapter && AppState.period && <div className={classes.title}>{ AppState.periodd.title }</div> }
        <h1 className={classes.name}>{obj.name}</h1>
        {isChapter && <Button onClick={handleClose}>Commencer</Button> }
      </div>



    </div>



  );
};

export default PopupObjective;
